<div class="searchfan-container" *ngIf="showData">
    <div *ngIf="showErrors" class="alert valign-children-middle">
        <div class="alert-error" role="img" aria-label="Error" aria-hidden="true">
            <i class="icon-badgealert"></i>
        </div>
        <div>
            <h2>{{!isUserAuthorized ? 'Warning' :'Error'}}</h2>
            <p>{{errorMessage}}</p>
        </div>
    </div>

    <form [formGroup]="searchFanForm" autocomplete="off">
        <section>
            <div class="form-group">
                <h1>{{this.pageJson.fan.heading}}</h1>
                <h2>{{this.pageJson.fan.description}} ,
                    <span class="firstSpan" style="display: inline-block; margin-left: 10px !important;">
                        {{this.adminName}}
                    </span>
                </h2>

                <h3>{{this.pageJson.fan.label}}</h3>
                <div class="check" *ngIf="!isUserAuthorized">
                    <div class="form-labl">Customer foundation account number: {{customerFan}}</div>
                    <div class="form-labl">Customer email address: {{customerEmail}}</div>
                </div>
                <div class="check" *ngIf="hideEmailFanFields">
                    <div>
                        <label for="{{this.pageJson.fan.formControlName+this.pageJson.fan.textBox.label}}">
                            <p>{{this.pageJson.fan.textBox.label}}</p>
                            <input *ngIf="!showEdit" type="text" maxlength="8" [numberOnly]="true" [ctnmask]="false"
                                (keyup)="checkFan($event)"
                                formControlName="{{this.pageJson.fan.textBox.formControlName}}"
                                id="{{this.pageJson.fan.formControlName+this.pageJson.fan.textBox.label}}"
                                class="form-control textbox" [placeholder]="this.pageJson.fan.textBox.placeholder"
                                required/>
                            <div class="fan-error-field" *ngIf="isFanInvalid || isFanEmpty">
                                <div class="text-danger">
                                    {{isFanEmpty ? this.pageJson.fan.textBox.emptyErrorMessage : this.pageJson.fan.textBox.invalidErrorMessage}}
                                </div>
                            </div>
                            <p class="divider" *ngIf="showEdit">
                                {{this.fanInContext}} <span class="secondSpan" *ngIf="showEdit">&nbsp;&nbsp;|
                                </span><a *ngIf="showEdit" class="disabled" class="btn btn-link"
                                    (click)="displayEdit()"> edit</a></p>
                        </label>
                    </div>
                </div>
                <div class="check" *ngIf="hideEmailFanFields">
                    <div>
                        <label for="{{this.pageJson.email.formControlName+this.pageJson.email.textBox.label}}">
                            <p class="email-label">{{this.pageJson.email.textBox.label}}</p>
                            <input type="text" (keyup)="checkEmail($event)"
                                formControlName="{{this.pageJson.email.textBox.formControlName}}"
                                id="{{this.pageJson.email.formControlName+this.pageJson.email.textBox.label}}"
                                class="form-control textbox" [placeholder]="this.pageJson.email.textBox.placeholder"
                                required [disabled]="!isUserAuthorized"/>
                            <div class="email-error-field" *ngIf="isEmailInvalid || isEmailEmpty">
                                <div class="text-danger">
                                    {{this.isEmailEmpty ? this.pageJson.email.textBox.emptyErrorMessage : this.pageJson.email.textBox.invalidErrorMessage}}
                                </div>
                            </div>
                        </label>
                    </div>
                </div>
                <div class="check" *ngIf="!isUserAuthorized">
                    <div>
                        <label for="customer-firstname">
                            <p class="email-label">Customer first name</p>
                            <input type="text" (keyup)="checkName('firstName', $event)"
                                formControlName="firstName"
                                id="customer-firstname"
                                class="form-control textbox" [placeholder]="'Enter customer first name'"
                                required/>
                            <div class="email-error-field" *ngIf="isFirstNameEmpty || isFirstNameInvalid">
                                <div class="text-danger">
                                    {{this.isFirstNameEmpty ? "First name is required." : "Invalid First name"}}
                                </div>
                            </div>
                        </label>
                    </div>
                </div>
                <div class="check" *ngIf="!isUserAuthorized">
                    <div>
                        <label for="customer-lastname">
                            <p class="email-label">Customer last name</p>
                            <input type="text" (keyup)="checkName('lastName', $event)"
                                formControlName="lastName"
                                id="customer-lastname"
                                class="form-control textbox" [placeholder]="'Enter customer last name'"
                                required/>
                            <div class="email-error-field" *ngIf="isLastNameEmpty || isLastNameInvalid">
                                <div class="text-danger">
                                    {{this.isLastNameEmpty ? "Last name is required." : "Invalid Last name"}}
                                </div>
                            </div>
                        </label>
                    </div>
                </div>
                
            </div>
            <div class="cta text-left" *ngIf="hideEmailFanFields">
                <button class="btn btn-secondary col-md-3 col-sm-12" [disabled]="disableSubmit" type="submit"
                    (click)="validate()">Search</button>
            </div>
            <div class="cta text-left col-md-3 col-sm-12" *ngIf="!isUserAuthorized">
                <button class="btn btn-default col-md-5 col-sm-12" (click)="cancelForm()">Cancel</button>
                <button class="btn btn-secondary col-md-5 col-sm-12" [disabled]="searchFanForm.get('firstName')?.invalid || searchFanForm.get('lastName')?.invalid" style="float:right" type="submit"
                    (click)="submitForm()">Continue</button>
            </div>
        </section>
    </form>
</div>